// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"89740018","214":"70cd385d","369":"dc268b01","401":"dbb30982","440":"9b4cd76f","633":"eba13c06","782":"ad58d531","942":"299d5370"}[chunkId] + ".chunk.js";
};